import { beian } from '@/server/beian'

const user = {
  state: {
    // 用户信息
    user: {
      user: ''
    }
  },
  mutations: {
    SET_USER(state, data) {
      if (data) {
        state.user = data
      }
    }
  },
  actions: {
    // 清空user数据
    clearUser: (context) => {
      context.commit('SET_USER', {})
    },
    getUser: (context) => {
      beian.get('/inner/user/info').then((response) => {
        let data = response.data
        if (data['state'] === 0) {
          context.commit('SET_USER', data.data)
        }
      })
    }
  },
  getters: {
    userInfo: state => state.user
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js